import { createFileRoute, Link } from "@tanstack/react-router";
import { useFleetSidebar } from "@/features/brewcontrol/use-fleet-sidebar";
import { trpc } from "@/hooks/trpc";

export const Route = createFileRoute("/brewcontrol/wirings/")({
  component: Wirings,
});

function Wirings() {
  useFleetSidebar();
  const query = trpc.brewcontrolConfig.wiringModels.useQuery();
  return (
    <div className="space-y-4 p-6">
      <h1 className="text-base font-medium">Wirings</h1>
      <p className="text-sm text-olive-11">
        Shared controller bindings for each equipment model. Save a version
        here, then apply it to individual vessels.
      </p>
      {query.error && (
        <p className="text-sm text-red-700">{query.error.message}</p>
      )}
      {query.isLoading ? (
        <p className="text-sm">Loading…</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="py-2">Equipment model</th>
              <th>Latest wiring</th>
              <th>Vessels</th>
            </tr>
          </thead>
          <tbody>
            {query.data?.map((model) => (
              <tr key={model.id} className="border-b border-olive-4">
                <td className="py-2">
                  <Link
                    className="underline underline-offset-4"
                    to="/brewcontrol/wirings/$modelId"
                    params={{ modelId: String(model.id) }}
                  >
                    {model.name}
                  </Link>
                </td>
                <td>
                  {model.latestVersion === null
                    ? "Not authored"
                    : `v${model.latestVersion}`}
                </td>
                <td className="font-mono">{model.vesselCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {query.data?.length === 0 && (
        <p className="text-sm text-olive-11">No fermentor equipment models.</p>
      )}
    </div>
  );
}
